import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useParams } from "react-router-dom";
import { Plugin } from "types";
import { elrondApi } from "../api/elrondApi";
import { ColumnLayout } from "../components/Layout/ColumnLayout";
import { PluginCanvas } from "../components/PluginCanvas";
import { useResource } from "../hooks/useResource";
import { Page } from "./Page";

export const PluginCanvasPage = () => {
    const { id } = useParams<{ id?: string }>();
    const { data: plugin } = useResource<Plugin>(["plugins", id], null, { api: elrondApi });

    return (
        <Page title={plugin?.ui?.label ?? "Xola"}>
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>{plugin?.ui?.label ?? "Xola"}</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>{(height) => <PluginCanvas plugin={plugin} height={height} />}</ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
